module.exports = __webpack_public_path__ + "img/hamochi.a81b09e7.png";